import en from './en';
import jp from './jp';
import tw from './tw';

export default {
	en,
	jp,
	tw,
};
